import dynamic from 'next/dynamic';
import { GeneralErrorProps } from './GeneralError.types';

export const GeneralError = dynamic<{ model: GeneralErrorProps }>(() =>
  import('./GeneralError').then(mod => mod.GeneralError)
);
